/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * スタートアップチャレンジ判定ステータス
 * @export
 * @interface PressReleaseStartupChallengeStatus
 */
export interface PressReleaseStartupChallengeStatus {
    /**
     * スタートアップチャレンジの判定ステータス  
     * UNAPPLICABLE: 対象外, 
     * FREE: 無料, 
     * FAILED: 失敗, 
     * DONE: 無料配信済, 
     * EXPIRED: 期間外
     * @type {string}
     * @memberof PressReleaseStartupChallengeStatus
     */
    status: PressReleaseStartupChallengeStatusStatusEnum;
    /**
     * スタートアップ種別  
     * VC: VC企業, 
     * A_PORT: A-PORT企業, 
     * STARTUP: 上記以外
     * @type {string}
     * @memberof PressReleaseStartupChallengeStatus
     */
    type: PressReleaseStartupChallengeStatusTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum PressReleaseStartupChallengeStatusStatusEnum {
    Unapplicable = 'UNAPPLICABLE',
    Free = 'FREE',
    Failed = 'FAILED',
    Done = 'DONE',
    Expired = 'EXPIRED'
}/**
* @export
* @enum {string}
*/
export enum PressReleaseStartupChallengeStatusTypeEnum {
    Vc = 'VC',
    APort = 'A_PORT',
    Startup = 'STARTUP'
}

export function PressReleaseStartupChallengeStatusFromJSON(json: any): PressReleaseStartupChallengeStatus {
    return PressReleaseStartupChallengeStatusFromJSONTyped(json, false);
}

export function PressReleaseStartupChallengeStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressReleaseStartupChallengeStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'type': json['type'],
    };
}

export function PressReleaseStartupChallengeStatusToJSON(value?: PressReleaseStartupChallengeStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'type': value.type,
    };
}

